var lx = lx || {};
lx.s2 = lx.s2 || {};
/* Created on 21.04.2017 by Davor
* Used for custom select2 items with options in array
* cascading parent item can be specified (pCascadeSelector)
* example: Ajax2Array("#ncState","getStates","#ncCountry");
*/
/* ex Select2Array function*/
lx.s2.array = function (pSelector, pLovProcess, pCascadeSelector) {
    var obj = {
        itemSelector: pSelector,
        process: pLovProcess,
        cascadeSelector: pCascadeSelector,
        data: [],
        getData: function (pInit) {
            var self = this;
            apex.server.process(this.process, 
                { x01: $(this.cascadeSelector).val() }, 
                {
                    dataType: "json",
                    success: function (d) {
                        self.data = $.map(d.row, function (item) { return { text: item.TEXT, id: item.ID }; });
                        if (pInit) { $(self.itemSelector).select2({ data: self.data }); }
                        else { $(self.itemSelector).select2('destroy').empty().select2({ data: self.data }); }
                    }
                });
        }
    };
    if (pCascadeSelector) $(pCascadeSelector).select2().on('change', function () { obj.getData(); });

    obj.getData(true);
    return obj;
};

/* ex select2Ajax function*/
lx.s2.ajax = function (pSelector, pLovProcess) {
    $(pSelector).select2({
        width: "resolve",
        minimumInputLength: 3,
        allowClear: true,
        placeholder: "- Select -",
        ajax: {
            url: "wwv_flow.show",
            dataType: 'json',
            quietMillis: 250,
            data: function (params) {
                return {
                    p_flow_id: $v("pFlowId"),
                    p_flow_step_id: $v("pFlowStepId"),
                    p_instance: $v("pInstance"),
                    p_request: "APPLICATION_PROCESS=" + pLovProcess,
                    x01: params.term
                };
            },
            processResults: function (data, params) {
                return {
                    results: $.map(data.row, function (item) {
                        return {
                            text: item.TEXT,
                            id: item.ID
                        }
                    })
                };
            },
            cache: true
        }
    });
};

Select2Array = lx.s2.array;
select2Ajax = lx.s2.ajax;